import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { environment } from './../environments/environment';

//primeng
import { MenuModule } from 'primeng/menu';
import { ButtonModule } from 'primeng/button';
import { PanelMenuModule } from 'primeng/panelmenu';
import { PanelModule } from 'primeng/panel';
import { CardModule } from 'primeng/card';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { ToastModule } from 'primeng/toast';
import { DialogModule } from 'primeng/dialog';
import { FieldsetModule } from 'primeng/fieldset';
import { MessageService, SharedModule } from 'primeng/api';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { SplitterModule } from 'primeng/splitter';

//App screens
import { HomeComponent } from './home/home.component';
import { AdminComponent } from './admin/admin.component';

//Generic Components
import { MenuScreenComponent } from './../components/menu-screen/menu-screen.component';

import { MenuButtonComponent } from './../components/menu-button/menu-button.component';

//Services
import { LocalService } from './../services/local.service';
import { UIService } from 'src/services/ui.service';

@NgModule({
  declarations: [AppComponent, MenuScreenComponent, MenuButtonComponent, HomeComponent, AdminComponent],
  imports: [
    //angular
    BrowserModule,
    FormsModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    //primeng
    ButtonModule,
    CardModule,
    DialogModule,
    MenuModule,
    PanelMenuModule,
    PanelModule,
    OverlayPanelModule,
    MessageModule,
    MessagesModule,
    SharedModule,
    SplitterModule,
    ToastModule,
    FieldsetModule,
  ],
  providers: [LocalService, MessageService, UIService],
  bootstrap: [AppComponent],
})
export class AppModule {}
